import qs from 'qs'
import { Shops } from '~/config/shops'
import { Route } from '~/config/routes.types'

export const replaceParams = (
  url: string,
  params: { [key: string]: string | number }
) => {
  const splittedUrl = url.split('/')
  const reduced = splittedUrl.reduce((acc, val) => {
    if (val.startsWith(':')) {
      const withoutColon = val.slice(1)
      return [...acc, params[withoutColon]]
    }
    return [...acc, val]
  }, [] as (string | number)[])
  return reduced.join('/')
}

interface UrlOptions {
  params?: Record<string, string | number>
  query?: Record<
    string,
    string | number | Record<string, string | number> | string[] | number[]
  >
  anchor?: string
}

export const createUrl = (
  route: Route,
  shop: Shops,
  options?: UrlOptions
): string => {
  const { query, params, anchor } = options || ({} as UrlOptions)
  let url = `/${route.paths[shop]}`

  if (params) {
    url = replaceParams(url, params)
  }

  if (query) {
    const queryString = qs.stringify(query, { arrayFormat: 'brackets' })

    url = `${url}?${queryString}`
  }

  if (anchor) {
    url = `${url}#${anchor}`
  }

  return url
}
